var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiscreet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.036,
    height: 16.325,
    viewBox: "0 0 50.036 16.325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1061",
    "data-name": "Grupo 1061",
    transform: "translate(-2483.424 7143.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7292",
    "data-name": "Trazado 7292",
    d: "M2537.839-7136.491c.542-1.2,3.384-4.935,11.906-4.636s12.112-1.794,12.112-1.794-5.271,18.392-24.018,13.457",
    transform: "translate(-29.397)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7293",
    "data-name": "Trazado 7293",
    d: "M2508.442-7136.491c-.542-1.2-3.383-4.935-11.906-4.636s-12.112-1.794-12.112-1.794,5.271,18.392,24.018,13.457",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_122",
    "data-name": "Elipse 122",
    cx: 3.958,
    cy: 2.107,
    rx: 3.958,
    ry: 2.107,
    transform: "translate(2511.881 -7135.563) rotate(-14.163)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_123",
    "data-name": "Elipse 123",
    cx: 2.107,
    cy: 3.958,
    rx: 2.107,
    ry: 3.958,
    transform: "translate(2496.296 -7133.414) rotate(-75.837)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscreet);
export default __webpack_public_path__ + "static/media/discreet.dd582f1d.svg";
export { ForwardRef as ReactComponent };